import { render } from "./photo-slider.vue?vue&type=template&id=37c53d32&scoped=true"
import script from "./photo-slider.vue?vue&type=script&lang=js"
export * from "./photo-slider.vue?vue&type=script&lang=js"

import "./photo-slider.vue?vue&type=style&index=0&id=37c53d32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c53d32"]])

export default __exports__